export const defaultFooter = `<footer>
  <div class="footer-content">
    <p>This documentation playground was created by Scalar. For help, questions or feedback don't hesitate to <a href="mailto:support@scalar.com">email our support.</a></p>
    <br />
    <p>You can fully customize or delete this footer by simply navigating to the footer section of the "customize" button  within our header.</p>
    <br />
    <a target="_blank" href="https://scalar.com/#docs">Features</a>
    <a target="_blank" href="https://scalar.com/#docs">About</a>
    <a target="_blank" href="https://scalar.com/#pricing">Pricing</a>
    <br />
    <a target="_blank" href="https://scalar.com/privacy-policy">Privacy Policy</a>
    <a target="_blank" href="https://scalar.com/terms-and-conditions">Terms of Service</a>
    <a target="_blank" href="https://scalar.com/#pricing">Pricing</a>
    <br />
    <p>© ${new Date().getFullYear()} Scalar</p>
  </div>
</footer>`

export const defaultFooterCSS = `footer {
  display: flex;
  flex-direction: column;
  font-size: var(--scalar-paragraph);
  line-height: 1.625;
  border-top: var(--scalar-border-width) solid var(--scalar-border-color);
}
footer p {
  margin-bottom: 25px;
}
footer a {
  width: fit-content;
  color:var(--scalar-color-accent)
}
footer a:hover {
  cursor: pointer;
  text-decoration: underline;
}
.footer-content {
  margin: 0 auto;
  padding: 50px;
}  
@media (max-width: 1000px) {
  footer {
    max-width: 100%;
  }
}
`
